import axiosPrivate from "@services/axiosPrivate";

export const getPostPayHistory = (historyData) => {
  return axiosPrivate.get(`/getPostPayProof`, {params: historyData});
};
